import { DELETE, DELETE_FAILED, DELETE_SUCCESS } from "./actionTypes"

let initialState = {
    delete: "",
    loading: false,
    success: false,
    error: ''
}

export const deleteReducer = (state = initialState, action) => {
    switch (action.type) {

        case DELETE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case DELETE_SUCCESS: return {
            ...state,
            delete: action.payload,
            loading: false,
            success: true
        }
        case DELETE_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }


        default: return state
    }
}